import { render, staticRenderFns } from "./subproperty-fee-info-page.vue?vue&type=template&id=2b476d6e&scoped=true&"
import script from "./subproperty-fee-info-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-fee-info-page.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-fee-info-page.vue?vue&type=style&index=0&id=2b476d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b476d6e",
  null
  
)

export default component.exports